import React, { useEffect, useState } from 'react';
import MasterCardIcon from '../../../assets/images/masterCardicon.svg';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import useCurrentUser from '../../../customHook/useCurrentUser';
import useSendNotification from '../../../customHook/useSendNotification';

function PayuSuccess() {
  const [currentDateTime, setCurrentDateTime] = useState<string>('');
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const { sendNotification } = useSendNotification();

  useEffect(() => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
    setCurrentDateTime(`${formattedDate} at ${formattedTime}`);

    // Send notification about successful subscription
    if (currentUser?._id) {
      sendNotification({
        userId: currentUser._id,
        type: 'subscription_created',
        data: {
          planName: currentUser.planName || 'Premium Plan',
        },
      });
    }
  }, [currentUser, sendNotification]);
  return (
    <div className="min-h-screen bg-[#B3B3B394] flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto">
        <div className="bg-white max-w-md w-full rounded-xl shadow-xl p-8 md:p-10 text-center relative overflow-hidden shadow-[#F8F5FF]">
          <div className="flex justify-center mb-4">
            <div className="p-4 rounded-full">
              <IoMdCheckmarkCircle color="#00E435" size={20} />
            </div>
          </div>

          <div className="flex justify-center flex-col items-center mb-4">
            <h1 className="text-[#6E3EF5] font-semibold text-lg mb-2">
              Payment Successful!
            </h1>

            <p className="text-[#707070] text-xs mb-4 leading-relaxed w-3/4">
              We have received your membership request.
            </p>
          </div>

          <hr className="border-gray-200 my-4" />

          <div className="text-left space-y-3 mb-8">
            <div>
              <p className="text-[#B7B7B7] text-sm">Status</p>
              <p className="font-semibold text-[#4A4A4A] flex items-center gap-1 text-sm mt-1">
                Successful
                <IoMdCheckmarkCircle color="#00E435" />
              </p>
            </div>

            <div>
              <p className="text-[#B7B7B7] text-sm">Date</p>
              <p className="font-semibold text-[#4A4A4A] text-xs mt-1">
                {currentDateTime}
              </p>
            </div>

            <div>
              <p className="text-[#B7B7B7] text-sm">Payment Method</p>
              <div className="grid grid-cols-2 items-center mt-1 bg-gradient-to-r from-[#f0ecfe] to-[#f6eeff] text-white h-20 px-4 py-2 rounded ">
                <img
                  src={MasterCardIcon}
                  alt="MasterCard logo"
                  className="h-6 mr-2"
                />
                <div className="font-semibold text-[#4A4A4A] text-xs ">
                  <p> MasterCard</p>
                  <p>**** **** **** 7898</p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gradient-to-r from-[#6E3EF5] to-[#8E5CFF] text-white py-3 rounded-xl font-semibold transition hover:opacity-90"
          >
            Proceed to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default PayuSuccess;
